import { GlobalWorkerOptions } from 'pdfjs-dist';
// Vite bundles the worker and returns its URL — no CDN, version always matches.
import PdfWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

export default defineNuxtPlugin(() => {
    GlobalWorkerOptions.workerSrc = PdfWorker;
});
